// Compact edit fields for the AI installment confirmation modal.
export function Field({ label, children }) {
  return (
    <label className="space-y-1 block w-full min-w-0">
      <span className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">{label}</span>
      {children}
    </label>
  );
}

export function ReadField({ label, value, tone = "text-slate-700" }) {
  return (
    <div className="space-y-1 w-full min-w-0">
      <p className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">{label}</p>
      <div className={`w-full box-border px-3 py-2 rounded-xl bg-slate-100/70 border border-dashed border-slate-300 text-sm font-bold tabular-nums ${tone}`}>
        {value ?? "—"}
      </div>
    </div>
  );
}

export const inputCls = "w-full min-w-0 box-border px-3 py-2 rounded-xl border border-border bg-white/70 text-sm focus:border-primary focus:outline-none";

export function fmtErr(e, t) {
  const map = { total_mismatch: "errTotal", end_date_mismatch: "errEnd", missing_fields: "errMissing" };
  return t(map[e.code] || "dataMismatch");
}

export function fmtCcy(n, ccy) {
  if (n == null || isNaN(n)) return "—";
  return `${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })} ${ccy}`;
}

// When user edits Total, compute a new Monthly that keeps N unchanged
// and makes (monthly × n) exactly match the user's typed total.
export function syncMonthlyFromTotal(totalStr, nStr, currentMonthlyStr) {
  const total = parseFloat(totalStr), n = parseInt(nStr, 10);
  const currMonthly = parseFloat(currentMonthlyStr);
  if (!(total > 0) || !(n > 0)) return null;
  const newMonthly = Math.round((total / n) * 100) / 100;
  if (isFinite(currMonthly) && Math.abs(newMonthly - currMonthly) < 0.01) return null;
  return String(newMonthly);
}
